export const firebaseConfig = {
    apiKey: "AIzaSyD-d7fz4seCpIOgTct7MdFvR1zzW5-GnAw",
    authDomain: "testvml-28823.firebaseapp.com",
    databaseURL: "https://testvml-28823.firebaseio.com",
    projectId: "testvml-28823",
    storageBucket: "testvml-28823.appspot.com",
    messagingSenderId: "579644105009"
}


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/environments/firebase.config.ts